export default {
  validations: []
}
